<template>
	<div class="loading-container">
		<div class="post-loading">
			<img
				src="/images/loading.gif"
				class="loading-gif"
			/>
		</div>
	</div>
</template>

<style lang="scss">
.loading-container {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: auto;
}

.post-loading {
	max-width: 96px;
}
</style>
